<form class="comment" [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="form-content">
    <img data-cy="comment-teacher-avatar" [src]="currentUser.avatar" alt="Avatar" />
    <div class="time-comment">
      @if (isShowCommentInfo) {
        <div class="teacher-name">
          <p class="truncate-text" data-cy="comment-teacher-name">{{ currentUser.name }}</p>
          <p>先生</p>
        </div>
      }
      @if (isShowCommentInfo) {
        <p class="assessment-time" data-cy="comment-created-at">{{ assessment.created_at }}</p>
      }
      <div class="text-comment">
        <textarea
          class="spen-mod-input-text"
          data-cy="comment-content"
          #textArea
          [appPlaceholder]="'コメントを入力'"
          formControlName="content"
          appAutoExpand
        ></textarea>
        @if (formErrors['content']) {
          <div class="spen-mod-error-content">
            {{ formErrors['content'].join(' ') }}
          </div>
        }
      </div>
    </div>
  </div>

  <div class="list-button">
    <button type="submit" class="spen-mod-btn is-primary" data-cy="comment-submit-button" [disabled]="isSubmitting || isContentInvalid()">
      {{ isEditForm() ? '保存する' : 'コメントする' }}
    </button>
    @if (isEditForm()) {
      <button type="button" class="spen-mod-btn" data-cy="comment-cancel-button" [disabled]="isSubmitting" (click)="cancelEdit()">
        キャンセル
      </button>
    }
    <span>
      @if (isEditForm()) {
        <a class="delete-comment spen-util-link" data-cy="comment-delete-button" (click)="deleteAssessment()">
          <i class="fa fa-trash-o"></i>削除する
        </a>
      }
    </span>
  </div>
</form>
